export default function Error() {
  return (
    <main className="h-[50vh] flex justify-center items-center p-0">
      <h1 className="text-white m-0">This page does not exist.</h1>
    </main>
  );
}
